import { useState } from "react";
import { DotLegalButton, useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { post } from "@common/api/apiShared";
import { EntityType } from "@common/Common.types";
import { useTranslation } from "../../../localization/useTranslation";

export interface IDownloadAllDocumentsButtonProps {
    entityType: EntityType;
    entityId: string;
    show: boolean;
}

export function DownloadAllDocumentsButton(props: IDownloadAllDocumentsButtonProps) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();
    const [submitting, setSubmitting] = useState(false);

    if (!props.show) {
        return null;
    }

    async function handleClick() {
        setSubmitting(true);
        try {
            await post(`/document/${props.entityType}/${props.entityId}/download-all`, {});
            snackbar.show(translateString("downloadAllExportStarted"));
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <DotLegalButton buttonType={"secondary"} isLoading={submitting} onClick={handleClick}>
            {translateString("downloadAll")}
        </DotLegalButton>
    );
}
